// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36VbE","newExpiryDate":"styles_newExpiryDate__1qBcV","footer":"styles_footer__2LB-g"};